import { render, staticRenderFns } from "./KIOSK.vue?vue&type=template&id=3afb33d4&scoped=true&"
import script from "./KIOSK.vue?vue&type=script&lang=js&"
export * from "./KIOSK.vue?vue&type=script&lang=js&"
import style0 from "./KIOSK.vue?vue&type=style&index=0&id=3afb33d4&lang=scss&scoped=true&"
import style1 from "./KIOSK.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb33d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
